import { useEffect, useState } from 'react'

export const useDelayMount = (isMounted: boolean, delayTime: number, callback?: (showDiv: boolean) => void) => {
  const [showDiv, setShowDiv] = useState(false)

  useEffect(() => {
    if ("production" === 'test') {
      setShowDiv(isMounted)
      return () => {}
    }

    let timeoutId: NodeJS.Timeout
    if (isMounted && !showDiv) {
      setShowDiv(true)
      if (callback) {
        callback(true)
      }
    } else if (!isMounted && showDiv) {
      timeoutId = setTimeout(() => {
        setShowDiv(false)
        if (callback) {
          callback(false)
        }
      }, delayTime)
    }
    return () => clearTimeout(timeoutId)
  }, [isMounted, delayTime, showDiv, callback])

  return showDiv
}
